import { Announcements } from "../components/Announcements";
import { PortalCompliance } from "../components/PortalCompliance";
import { PublicLinks } from "../components/PublicLinks";
import { PageHeader } from "../components/ui";

export default function MobileMonitoring() {
  return (
    <div data-testid="mobile-monitoring-page" className="space-y-6">
      <PageHeader title="Monitoring Mobile Siswa" subtitle="Rekap status HP siswa selalu tampil di atas · pengumuman, link publik, dan tindak lanjut WA di bawahnya" />
      <PortalCompliance />
      <Announcements />
      <PublicLinks />
    </div>
  );
}
